import { render, staticRenderFns } from "./PaymentDiffTable.vue?vue&type=template&id=2cfb4e16&"
import script from "./PaymentDiffTable.vue?vue&type=script&lang=js&"
export * from "./PaymentDiffTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDiffTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports